import { render } from "./MainSectionOne.vue?vue&type=template&id=2a0a0e48&scoped=true"
import script from "./MainSectionOne.vue?vue&type=script&lang=js"
export * from "./MainSectionOne.vue?vue&type=script&lang=js"

import "./MainSectionOne.vue?vue&type=style&index=0&id=2a0a0e48&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0a0e48"]])

export default __exports__